<template>
  <div id="configuration">
    <v-container class="pa-0">
      <v-layout>
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute left :to="{ path: '/admin/families'}" class="ml-3 pf-btn-fab">
            <v-icon>arrow_back</v-icon>
          </v-btn>            
        </v-flex>
      </v-layout>
    </v-container>
    <v-container class="-border" >
      <v-layout wrap>
        <v-flex xs12 class="button-container pr-3 text-xs-right">
          <div class="d-inline-flex" v-if="selectedData">
            <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-form ref="video_app_settings">
        <v-layout wrap class="pr-4 pl-4 mb-3">
          <v-flex class="xs6">
            <h5 class=" mb-3  custom-title">
              <v-label>Account Name:</v-label> {{accountData.name}}
            </h5>
          </v-flex>
          <v-flex class="xs6">
            <h5 class=" mb-3 custom-title">
              <v-label>Nickname:</v-label> {{accountData.nickname}}
            </h5>
          </v-flex>
          </v-layout>
          <v-layout wrap class="pr-4 pl-4">
          <v-flex class="xs12">
            <h5 class="pf-sub-head mb-3 mt-4 custom-title">
              <b>Account Settings</b>
            </h5>
          </v-flex>
          </v-layout>
          <v-layout wrap class="pr-4 pl-4">
          <v-flex class="xs12 sm4 pr-4">
            <v-select
              v-model="accountData.is_private"
              :items="yesOrNoArray"
              :item-text="'text'"
              :item-value="'value'"
              label="Is Private"
              @input="changedData"
            ></v-select>
          </v-flex>
          <v-flex class="xs12 sm4 pr-4">
            <v-select
              v-model="accountData.allow_contact"
              :items="yesOrNoArray"
              :item-text="'text'"
              :item-value="'value'"
              label="Allow Contact"
              @input="changedData"
            ></v-select>
          </v-flex>
          <v-flex class="xs12 sm4">
            <v-select
              v-model="accountData.placement_status.status"
              :items="placementList"
              :item-text="'text'"
              :item-value="'value'"
              label="Placement Status"
              @input="changedData('placementStatus')"
            ></v-select>
          </v-flex>
          </v-layout>
          <v-layout wrap class="pr-4 pl-4">
          <v-flex class="xs12">
            <h5 class="pf-sub-head mb-3 mt-4 custom-title">
              <b>Video App Settings</b>
            </h5>
          </v-flex>
          </v-layout>
          <v-layout wrap class="pr-4 pl-4">
          <v-flex class="xs12 pr-4" :class="{ 'sm3': project.length, 'sm4': !project.length }" >
            <v-select
              v-model="accountData.video_app_settings[0].no_of_sections"
              :items="noOfSections"
              label="Number of sections"
              @input="changedData"
            ></v-select>
          </v-flex>
          <v-flex class="xs12 pr-4" :class="{ 'sm3': project.length, 'sm4': !project.length }" >
            <v-select
              v-model="accountData.video_app_settings[0].no_of_videos_per_section"
              :items="videosPerSection"
              label="Number of videos per section"
              @input="changedData"
            ></v-select>
          </v-flex>
          <v-flex class="xs12 pr-4" :class="{ 'sm3': project.length, 'sm4': !project.length }">
            <v-text-field label="Length of video (minutes)" v-model="accountData.video_app_settings[0].length_of_video" @input="changedData"></v-text-field>
          </v-flex>
          <v-flex v-if="projectCall && project.length" class="xs12 sm3">
            <v-menu
                v-model="doc.picker"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="FormattedDate"
                    :label="doc.label"
                    hint="MM/DD/YYYY"
                    persistent-hint
                    readonly
                    clearable
                    prepend-icon="event"
                    @blur="project[0].completion_date = parseDate(FormattedDate); isFormDataChanged = true; selectedData = true"
                    v-on="on"
                    class="pr-4 pl-4"
                    @input="isFormDataChanged = true; selectedData = true"
                  ></v-text-field>
                </template>
                <v-date-picker :max="new Date().toISOString().substr(0, 10)" v-model="project[0].completion_date" @input="doc.picker = false"></v-date-picker>
              </v-menu>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pr-4 pl-4">
          <v-flex class="xs12">
            <h5 class="mb-3 mt-4 custom-title">
              <b>Membership</b>
            </h5>
          </v-flex>
        </v-layout>
        <v-layout wrap class="pr-4 pl-4 flext-start">
          <v-flex sm4>
            <h5>Membership Type: <b>{{ accountData.membership }}</b></h5>
          </v-flex>
          <v-flex sm4 v-if="IsSubscriptionActive" class="pt-0 ml-1"> 
            <a class="link" @click="cancelMembership">CANCEL SUBSCRIPTION</a>
          </v-flex>
        </v-layout>
      </v-form>
      <v-layout wrap class="taskSettings pr-4 pl-4 mt-4 mb-3">
        <v-flex class="xs12">
          <h5 class="pf-sub-head mb-3 mt-4 custom-title">
            <b>Tasks</b>
          </h5>
        </v-flex>
        <v-flex class="xs6">
          <v-card class="ml-2 mt-3 mr-2 mb-3">
            <vue-perfect-scrollbar class="assignedTasks">
              <v-card-title>
                <h5>Assigned Tasks</h5>
                </v-card-title>
              <v-card-text>
                <v-card-actions>
                  <v-btn class="pf-btn pf-bg-teal" :disabled="!this.removeTasks.length" @click="removeSelectedTasks">Remove selected tasks</v-btn>
                </v-card-actions>
                <template v-for="(accountTask, i) in accountData.task">
                  <v-list-tile :key="i" avatar v-if="accountTask.name">
                    <v-list-tile-content>
                      <v-checkbox v-model="removeTasks" :value="accountTask.task" :label="`${ accountTask.name } - ${ accountTask.status }`" color="teal"></v-checkbox>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
                <p v-if="!accountData.task.length">No tasks have been assigned.</p>
              </v-card-text>
            </vue-perfect-scrollbar>
          </v-card>
        </v-flex>
        <v-flex class="xs6">
          <v-card class="ml-2 mt-3 mr-2 mb-3">
            <vue-perfect-scrollbar class="assignTasks">
              <v-card-title>
                <h5>Associate Tasks</h5>
                </v-card-title>
              <v-card-text>
                <v-card-actions>
                  <v-btn class="pf-btn pf-bg-teal" :disabled="!this.selectedNewTasks.length" @click="assignNewTasks">Assign selected tasks</v-btn>
                </v-card-actions>
                <template v-for="(taskItem, i) in availableTasks">
                  <v-list-tile :key="i" avatar v-if="accountData.task.findIndex(x => x.task === taskItem.id) === -1">
                    <v-list-tile-content>
                      <v-checkbox v-model="selectedNewTasks" :value="taskItem.id" :label="taskItem.name" color="teal"></v-checkbox>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
                <p v-if="!availableTasks.length">No tasks available to be assigned with the account</p>
              </v-card-text>
            </vue-perfect-scrollbar>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout wrap class="pr-4 pl-4 mt-4" v-if="selectedData">
        <v-flex xs12 class="button-container pr-0 text-xs-right">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" @click="hideButtons">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>    
<script>
/* global session store config  */

import swal from 'sweetalert2';
import { update, getCollection, request } from '../helpers/helpers';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
export default {
  name: 'AccountSettings',
  components: { VuePerfectScrollbar },
  data: () => ({
    entity: 'Account',
    selectedData: false,
    FormattedDate: null,
    projectCall: false,
    isFormDataChanged: false,
    searchIndex: -1,
    doc: {
      label: 'Project Completion',
      value: null,
      picker: false
    },
    formRules: {
      positive_number: [v => !!v || 'Please enter valid number', v => /^\d+$/.test(v) || 'Please enter valid number']
    },
    accountData: {},
    noOfSections: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    videosPerSection: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    yesOrNoArray: [
      {
        value: true,
        text: 'Yes'
      },
      {
        value: false,
        text: 'No'
      }
    ],
    placementList: ['Waiting', 'Matched', 'Placed'],
    project: [],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage
    },
    taskHeaders: [
      { text: '#', value: '', align: 'left' },
      { text: 'Task', value: 'name' },
      { text: 'Status', value: '' }
    ],
    selectedTasks: [],
    selectedNewTasks: [],
    removeTasks: [],
    membershipTask: [],
    placementStatusUpdated: false
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    SearchResult: {
      set (value) {
        store.commit('setSearchResult', value);
      },
      get () {
        return store.state.SearchResult;
      }
    },
    Task: {
      set (value) {
        store.commit('setTask', value);
      },
      get () {
        return store.state.Task;
      }
    },
    IsSubscriptionActive: {
      set (value) {
        store.commit('setIsSubscriptionActive', value);
      },
      get () {
        return store.state.IsSubscriptionActive;
      }
    },
    availableTasks () {
      if (this.membershipTask.length) {
        return this.membershipTask.filter(x => this.accountData.task.findIndex(y => y.task === x.id) === -1);
      }
      return [];
    }
  },
  watch: {
    project: {
      handler: function (after, before) {
        this.FormattedDate = this.formatDate((this.project[0].completion_date));
      },
      deep: true
    }
  },
  async created () {
    try {
      this.accountData = JSON.parse(JSON.stringify(this.$route.params.item));
      this.searchIndex = this.SearchResult.findIndex(item => item.id === this.accountData.id);
      if (!this.accountData.video_app_settings[0]) {
        this.accountData.video_app_settings.push({
          no_of_sections: 5,
          no_of_videos_per_section: 1,
          length_of_video: '2.30'
        });
      }
      await this.projectInitialize();
      if (this.project.length) {
        this.project[0].completion_date = this.project[0].completion_date.substr(0, 10);
      }
      await this.getMembershipSubscription();
      await this.getTasks();
    } catch (e) {
      this.hideButtons();
      this.$router.push({ path: '/admin/families' });
    }
  },
  methods: {
    async projectInitialize () {
      let sessionUser = session.getSession();
      let where = { account: this.accountData.id };
      let { error, data } = await getCollection('Project', true, 0, '', where);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          this.project = data;
        }
        this.projectCall = true;
      }
    },
    async getMembershipSubscription () {
      let where = {
        account: this.accountData.id,
        type: 'Membership',
        status: 'Subscribed'
      };
      let { error, data, count } = await getCollection('PaymentSubscription', true, 0, '', where);
      if (error) {
        console.log(error);
      } else {
        if (data.length > 0) {
          this.IsSubscriptionActive = true;
        }
      }
    },
    cancelMembership () {
      swal.fire({
        title: 'Are you sure?',
        text: 'Are you sure that you want to cancel the membership subscription?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, cancel it!'
      }).then(async (result) => {
        if (result.value) {
          (async () => {
            let payload = {
              account: this.accountData.id,
              subscription_type: 'Membership'
            };
            let { error, data } = await request('PaymentSubscription/Cancel', 'PUT', payload);
            if (error) {
              console.log('error', error);
              swal.fire({
                type: 'warning',
                title: 'Error',
                text: typeof error === 'string' ? error : (error.message || 'Something went wrong, please check with your agency'),
                showConfirmButton: true,
                onClose: () => {}
              });
              return;
            } else {
              /* Update the membership status in state */
              this.IsSubscriptionActive = false;
              swal.fire({
                type: 'success',
                title: 'Success',
                text: 'The membership subscription was cancelled successfully',
                showConfirmButton: false,
                timer: 2500,
                onClose: () => {
                  // 
                }
              });
            }
          })();
        }
      });
    },
    async getTasks () {
      if (!this.Task.length) {
        let entity = `Task`;
        let { error, data } = await getCollection(entity, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            store.commit('setTask', data);
            this.getBymembership();
          }
        }
      } else {
        this.getBymembership();
      }
    },
    getBymembership () {
      this.membershipTask = this.Task.filter(task => task.membership.includes(this.accountData.membership));
    },
    async assignNewTasks () {
      if (this.selectedNewTasks.length) {
        // Update the account entity with the new tasks
        let account = JSON.parse(JSON.stringify(this.accountData));
        let tasks = account.task || [];
        let task = {};
        let parentTask = {};
        this.selectedNewTasks.forEach(x => {
          if (x) {
            parentTask = this.membershipTask[this.membershipTask.findIndex(i => i.id === x)];
            task = {
              task: x,
              name: parentTask.name,
              description: parentTask.description ? parentTask.description : '',
              links: parentTask.links,
              action_link: parentTask.action_link || '',
              force_complete: parentTask.force_complete || false,
              status: 'Open'
            };
            tasks.push(task);
          }
        });
        account.task = tasks;
        account.updated_from = 'default';
        if (account.human && account.human.length) {
          account.human[0].user = account.human[0].user.id;
          if (account.human.length > 1 && account.human[1].user) {
            account.human[1].user = account.human[1].user.id;
          }
        }
        let { error, data, status } = await update('Account', account, account.id);
        if (error) {
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to update the tasks, please try again'
          };
        } else {
          this.SearchResult[this.searchIndex].task = this.accountData.task = data.task;
          window.getApp.$emit('SearchResultUpdate', this.SearchResult);
          this.selectedNewTasks = this.removeTasks = [];
          swal.fire({
            type: 'success',
            title: 'Selected tasks added to the account.',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {}
          });
        }
      }
    },
    async removeSelectedTasks () {

      if (this.removeTasks.length) {
        let account = JSON.parse(JSON.stringify(this.accountData));
        // Update the account entity with the new tasks list
        let tasks = account.task || [];
        if (tasks.length) {
          let removeTaskIndex = {};
          this.removeTasks.forEach(x => {
            removeTaskIndex = tasks.findIndex(i => i.task === x);
            tasks.splice(removeTaskIndex, 1);
          });
          account.task = tasks;
          account.updated_from = 'default';
          if (account.human && account.human.length) {
            account.human[0].user = account.human[0].user.id;
            if (account.human.length > 1 && account.human[1].user) {
              account.human[1].user = account.human[1].user.id;
            }
          }
          let { error, data, status } = await update('Account', account, account.id);
          if (error) {
            console.log('error', error);
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'Failed to update the tasks, please try again'
            };
          } else {
            this.SearchResult[this.searchIndex].task = this.accountData.task = data.task;
            window.getApp.$emit('SearchResultUpdate', this.SearchResult);
            this.removeTasks = this.selectedNewTasks = [];
            swal.fire({
              type: 'success',
              title: 'Selected tasks have been removed.',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {}
            });
          }
        }
      }
    },
    formatDate (date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate (date) {
      if (!date) return '';
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    changedData (changedFrom = null) {
      if (changedFrom && changedFrom === 'placementStatus') {
        this.placementStatusUpdated = true;
      }
      this.selectedData = true;
    },
    hideButtons () {
      this.selectedData = false;
    },
    async projectSave () {
      this.project[0].update_from = 'Complete';
      console.log(this.project[0]);
      let { error, data, status } = await update('Project', this.project[0], this.project[0].id);
      if (error) {
        console.log('error', error);
      } else {
        this.project[0] = data;
      }
    },
    async save () {
      if (this.isFormDataChanged) await this.projectSave();
      this.accountData.video_app_settings[0].no_of_sections = (this.accountData.video_app_settings[0].no_of_sections) ? parseInt(this.accountData.video_app_settings[0].no_of_sections, 10) : 0;
      this.accountData.video_app_settings[0].no_of_videos_per_section = (this.accountData.video_app_settings[0].no_of_videos_per_section) ? parseInt(this.accountData.video_app_settings[0].no_of_videos_per_section, 10) : 0;
      this.searchIndex = this.SearchResult.findIndex(item => item.id === this.accountData.id);

      // Replace the user object to id string
      if (this.accountData.human && this.accountData.human.length) {
        this.accountData.human[0].user = this.accountData.human[0].user.id;
        if (this.accountData.human.length > 1 && this.accountData.human[1].user) {
          this.accountData.human[1].user = this.accountData.human[1].user.id;
        }
      }

      if (this.placementStatusUpdated) {
        this.accountData.updated_from = 'placementStatus';
      }
      let { error, data, status } = await update(this.entity, this.accountData, this.accountData.id);
      if (error) {
        console.log('error', error);
      } else {
        this.SearchResult[this.searchIndex] = data;
        swal.fire({
          type: 'success',
          title: 'Details saved successfully',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            this.hideButtons();
            this.$router.push({ path: '/admin/families' });
          }
        });
      }
    }
  }
};
</script>

<style scoped>
  .assignedTasks, .assignTasks {
    max-height: 500px;
    overflow-y: scroll;
  }
</style>


// WEBPACK FOOTER //
// src/pages/AccountSettings.vue